import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';
import { Product } from './product.model';

@Injectable({
  providedIn: 'root'
})
export class ProductService {


  constructor(private http: HttpClient, private globle: Globle) {
  }

  getAll(subCatgId: number, status: number) {
    return this.http.get<Product[]>(this.globle.APIURL + "allproducts/" + subCatgId + "?status=" + status);
  }

  getById(id: number) {
    return this.http.get<Product>(this.globle.APIURL + "productbyid/" + id);
  }

  Create(product: Product) {
    return this.http.post(this.globle.APIURL + "products", product)
  }

  Update(product: Product) {
    return this.http.put(this.globle.APIURL + "products", product)
  }

  Delete(id: number) {
    return this.http.delete(this.globle.APIURL + "products/" + id)
  }

  uploadImage(formdata: any) {
    return this.http.post<any>(this.globle.APIURL + "products/upload", formdata)
  }

  deleteProductCard(id: number, productId: number) {
    return this.http.delete(this.globle.APIURL + "productcards/" + id + "/" + productId)
  }

  getUserCategory() {
    return this.http.get<[]>(this.globle.APIURL + "usercategory");
  }

  checkDublicateCode(obj: any) {
    return this.http.put<any>(this.globle.APIURL + "products/checkdublicatecardcode", obj)
  }

  checkDublicateSerial(obj: any) {
    return this.http.put<any>(this.globle.APIURL + "products/checkdublicateserial", obj)
  }

  getProductCardsCount(productid: number, status: number) {
    return this.http.get<any>(this.globle.APIURL + "productcards/getcount/" + productid + "/" + status);
  }

  UpdateProductLock(obj: any) {
    return this.http.put(this.globle.APIURL + "products/updateproductlock", obj)
  }

}
